import { DocsEntityGroup } from "../../model/docs/entities/SDKDocsEntityGroup";
import { DocsEntityPage } from "../../model/docs/entities/SDKDocsEntityPage";
import { DocsEntityType } from "../../model/enums/SDKDocsEntityType";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DocsEntityItemResolver {
    constructor() {
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Properties
        this.hashedItems = new Map();
        this.resolvedItems = new Map();
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Resolution
    resolveMultiplayerItems(pageDetails, groupDetails) {
        // Hash groups for faster lookup + find root group.
        let rootGroupModel;
        // Fix types
        pageDetails.forEach((item) => {
            item.type = DocsEntityType.page;
        });
        groupDetails.forEach((item) => {
            item.type = DocsEntityType.group;
        });
        groupDetails.forEach((item) => {
            this.hashedItems.set(item.persistentId, item);
            if (item.isRoot || item.title === "Documentation Root") {
                // Only temporary
                rootGroupModel = item;
            }
        });
        // @ts-expect-error TS(2454): Variable 'rootGroupModel' is used before being assigning
        if (!rootGroupModel) {
            throw new Error(`Incosistent model detected, missing root group`);
        }
        // Hash pages for faster lookup.
        pageDetails.forEach((page) => {
            this.hashedItems.set(page.persistentId, page);
        });
        // Create structured chain of objects
        const rootGroup = new DocsEntityGroup(rootGroupModel);
        this.resolveItemsForGroup(rootGroup);
        // Retrieve created objects
        const items = Array.from(this.resolvedItems.values());
        return items;
    }
    resolveItemsForGroup(group) {
        // Store items
        this.resolvedItems.set(group.persistentId, group);
        // Resolve children of one group
        group.childrenIds.forEach((childId) => {
            // Find model from the loaded items
            const childModel = this.hashedItems.get(childId);
            if (!childModel) {
                throw new Error(`Inconsistent group / page model detected in one of the documentation items, missing ${childId}`);
            }
            if (childModel.type === "Group") {
                // If it is a group, then create a group
                const subgroup = new DocsEntityGroup(childModel);
                subgroup.parent = group;
                subgroup.type = DocsEntityType.group;
                group.children.push(subgroup);
                this.resolveItemsForGroup(subgroup);
            }
            else {
                // Otherwise, create a page using the data we obtained from the content call
                const pageId = childModel.persistentId;
                const pageModel = this.hashedItems.get(pageId);
                const page = new DocsEntityPage(pageModel);
                // Link parents properly
                page.parentId = group.persistentId;
                page.parent = group;
                page.type = DocsEntityType.page;
                group.children.push(page);
                // Store items
                this.resolvedItems.set(page.persistentId, page);
            }
        });
    }
}
